import React from 'react';
import CTA from "../../../components/Constant/cta/CTA";
import WhySection from "../../../components/WhySection/WhySection";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards";
import SEO from "../../../utils/SEO";

export default function RealEstateInvestment() {

    return (
        <main className='main'>
            <SEO
                title="Real Estate Investment | Residency & Citizenship Programs"
                description="nvest in UAE real estate to secure Golden Visa residency. Enjoy freehold ownership, strong rental yields, and tax-free property benefits. "
                keywords=" UAE real estate investment, Dubai property investment, UAE Golden Visa property, Abu Dhabi real estate, freehold property UAE, residency by property UAE, Dubai rental yields, UAE investment visa property "
                url="/real-estate-investment"
            />
            <IntroSection
                title="Real Estate Investment"
                subtitle="Residency & Citizenship Through Global Property Investment"
                description="Real estate is one of the most popular and secure ways to obtain residency or citizenship in leading jurisdictions. Whether you are seeking Golden Visas in Europe, long-term residency in Asia, or lifestyle investments in the Caribbean, property investment offers both lifestyle benefits and wealth growth."
                badges={[
                    "Residency & Citizenship",
                    "Rental Yields",
                    "Asset Protection"
                ]}
                buttonText="Request a Real Estate Investment Consultation →"
                buttonLink="/quote"
                imageSrc={require("../../../assets/images/real-estate/real-esate-investment-hero.png")}
                imageAlt="Real Estate Investment for Residency & Citizenship"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title="Why Real Estate Investment?"
                        blocks={[
                            {
                                items: [
                                    { title: "Residency & Citizenship", text: "Unlock EU or global residency rights." },
                                    { title: "Capital Growth", text: "Invest in rising property markets." },
                                    { title: "Rental Income", text: "Short-term and long-term rental yields." },
                                    { title: "Wealth Diversification", text: "Secure assets abroad." },
                                    { title: "Lifestyle Benefits", text: "Live, work, and study in your chosen country." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Key Programs by Jurisdiction"
                        blocks={[
                            {
                                title: "🇬🇷 Greece",
                                items: [
                                    { text: "Golden Visa: €250,000+ real estate." },
                                    { text: "Residency for whole family, renewable every 5 years." },
                                    { text: "Popular cities: Athens, Thessaloniki, Crete, islands." }
                                ]
                            },
                            {
                                title: "🇪🇸 Spain",
                                items: [
                                    { text: "Golden Visa: €500,000+ real estate." },
                                    { text: "Residency for family, free Schengen travel." },
                                    { text: "Popular areas: Madrid, Barcelona, Marbella, Valencia." }
                                ]
                            },
                            {
                                title: "🇨🇾 Cyprus",
                                items: [
                                    { text: "Permanent Residency: €300,000+ new residential property." },
                                    { text: "Citizenship path after 7 years." },
                                    { text: "Popular areas: Limassol, Larnaca, Paphos." }
                                ]
                            },
                            {
                                title: "🇮🇹 Italy",
                                items: [
                                    { text: "Real estate supports Investor Visa & Elective Residency." },
                                    { text: "Combine with Non-Dom €100k flat tax regime." },
                                    { text: "Popular areas: Milan, Rome, Tuscany, Lake Como, Amalfi Coast." }
                                ]
                            },
                            {
                                title: "🇦🇪 United Arab Emirates (Dubai & Abu Dhabi)",
                                items: [
                                    { text: "Golden Visa: AED 2M (~$545,000) property." },
                                    { text: "5–10 year renewable residency." },
                                    { text: "Strong rental yields (6–8% average)." }
                                ]
                            },
                            {
                                title: "🇮🇩 Indonesia (Bali)",
                                items: [
                                    { text: "PT PMA company for property ownership." },
                                    { text: "Residency via Investor KITAS or Second Home Visa." },
                                    { text: "Popular areas: Canggu, Seminyak, Ubud, Uluwatu." }
                                ]
                            },
                            {
                                title: "🌴 Caribbean (Dominica, St. Lucia, etc.)",
                                items: [
                                    { text: "Citizenship by Investment via real estate ($200,000+)." },
                                    { text: "Visa-free travel to 140+ countries." },
                                    { text: "Short processing times (3–6 months)." }
                                ]
                            }
                        ]}
                    />

                    <ServiceCards
                        title="Typical Investment Models"
                        services={[
                            { title: "Residential Villas & Apartments" },
                            { title: "Hotel Residences & Branded Developments" },
                            { title: "Holiday Rentals (Airbnb)" },
                            { title: "Commercial & Mixed-Use Real Estate" }
                        ]}
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <CTA
                        title="Ready to invest in property and secure global residency?"
                        description="Offshore Advisory provides real estate investment guidance, visa processing, and full structuring support."
                        buttonText="Book a Real Estate Investment Consultation Today →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "What is the lowest property threshold for residency?",
        content: [
            { type: "answer", text: "Greece offers the lowest in the EU at €250,000." },
        ],
    },
    {
        question: "Does property investment lead to citizenship?",
        content: [
            { type: "answer", text: "Yes, in many countries after residency periods (e.g., Spain 10 years, Cyprus 7 years)." },
        ],
    },
    {
        question: "Can I rent out my property?",
        content: [
            { type: "answer", text: "Yes, most programs allow long-term and short-term rentals." },
        ],
    },
    {
        question: "Can I include my family?",
        content: [
            { type: "answer", text: "Yes, spouses and children are included in most residency schemes." },
        ],
    },
    {
        question: "Do I need to live full-time in the country?",
        content: [
            { type: "answer", text: "Some programs (e.g., Greece, Spain) have no minimum stay requirements." },
        ],
    },
];
